import React from 'react'
import { ScreeningQuestion } from 'types/campaign'

interface ScreeningQuestionTextProps {
    question: ScreeningQuestion
    index: number
    value: string | number
    onChange: (value: string) => void
    highlightError?: boolean
}

const ScreeningQuestionText: React.FC<ScreeningQuestionTextProps> = ({
    question,
    index,
    value,
    onChange,
    highlightError = false,
}) => (
    <div className="screening-question">
        <p className="screening-question__title">
            {index + 1}. {question.question}
        </p>
        <input
            type="text"
            className={`screening-question__text-input${
                highlightError ? ' screening-question__text-input--error' : ''
            }`}
            value={String(value ?? '')}
            onChange={(e) => onChange(e.target.value)}
            placeholder="Your answer"
        />
        {highlightError && (
            <div className="text-danger fs-14 mt-1">Please enter a valid answer</div>
        )}
    </div>
)

export default ScreeningQuestionText
